import { CodeBlockTagsIcon } from './CodeBlockTagsIcon';

/**
 * author: frankgrinaert
 * id E13525B2-A482-46B5-B01E-5CE520FC2C1D
 * name code-block-tags
 * version: 7.3.67
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/code-block-tags.svg
 * tags
 * - Developer / Languages 
 */
export const CodeBlockHtmlIcon = CodeBlockTagsIcon;
export default CodeBlockHtmlIcon